module.exports = __webpack_public_path__ + "static/media/sign_out.08526ebc.svg";